module.exports = __webpack_public_path__ + "img/zbz.845afed1.png";